import React from 'react'
import { Card as SCard, Icon } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import { history } from '../../../redux/store'
import styles from './card.module.css'

const Card = ({
  title = 'Spectro',
  iconName = 'play',
  color = 'blue',
  to = '/',
  enabled = false,
}) => (
  <SCard
    centered
    style={{ background: color, cursor: 'pointer', margin: '20px !important' }}
    onClick={() => {
      if (enabled) history.push(to)
    }}
  >
    <SCard.Content>
      <Icon style={{ float: 'right' }} inverted size="large" name={iconName} />
      <SCard.Header className={styles.cardHeader}>{title}</SCard.Header>
    </SCard.Content>
  </SCard>
)

Card.propTypes = {
  title: PropTypes.string,
  iconName: PropTypes.string,
  color: PropTypes.string,
  to: PropTypes.string,
  enabled: PropTypes.bool,
}

export default Card
